export const TRIMMED_PARTNER = `{
  id
  name
  display_name
  logo
  aivy_form_id
  createdAt
  updatedAt
}`
